(function () {
  function updateImageLayouts() {
    const items = document.querySelectorAll('.cg-item-inner');
    const w = window.innerWidth;

    items.forEach(inner => {
      const d = inner.dataset.layoutDesktop || 'above';
      const t = inner.dataset.layoutTablet || 'inherit';
      const m = inner.dataset.layoutMobile || 'inherit';
      const side = inner.dataset.imgSide || 'left';

      let active = d;
      if (w >= 750 && w <= 989) {
        active = (t === 'inherit') ? d : t;
      } else if (w < 750) {
        const tResolved = (t === 'inherit') ? d : t;
        active = (m === 'inherit') ? tResolved : m;
      }

      inner.classList.remove('layout-above', 'layout-below', 'layout-beside', 'left', 'right');
      inner.classList.add('layout-' + active);
      if (active === 'beside') inner.classList.add(side);
    });
  }

  if (!document.querySelector('.cg-item-inner')) return;

  updateImageLayouts();
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateImageLayouts, 100);
  });
})();
